export default function getKRItems(imgA: any, imgB: any, imgC: any, t: any) {
    return {
        items: [
            {
                isAmazon: true,
                pc: imgA.pc,
                label: '',
                title: t('item1_title'),
                desc: t('item1_desc'),
                link_more: 'https://kr.ecoflow.com/products/river-3-ups-portable-power-station',
                icons: [
                    {
                        icon: 'EFCompact',
                        title: t('item1_text1'),
                    },
                    {
                        icon: 'EFRuntime',
                        title: t('item1_text2'),
                    },
                    {
                        icon: 'EFBattery',
                        title: t('item1_text3'),
                    },
                    {
                        icon: 'EFUPS',
                        title: t('item1_text4'),
                    },
                ],
            },
            {
                isDialog: false,
                isAmazon: true,
                pc: imgB.pc,
                link_more: 'https://kr.ecoflow.com/products/ecoflow-river-3-plus-portable-power-station',
                label: t('price_label2_a'),
                title: t('item2_title'),
                desc: t('item2_desc'),
                icons: [
                    {
                        icon: 'EFRuntime',
                        title: t('item2_text1'),
                    },
                    {
                        icon: 'EFExpand',
                        title: t('item2_text2'),
                    },
                    {
                        icon: 'EFBattery',
                        title: t('item2_text3'),
                    },
                    {
                        icon: 'EFUPS',
                        title: t('item2_text4'),
                    },
                ],
            },
            {
                isDialog: false,
                isAmazon: true,
                pc: imgC.pc,
                link_more: 'https://kr.ecoflow.com/products/ecoflow-river-3-plus-portable-power-station-add-extra-battery',
                label: t('price_label3_a'),
                title: t('item3_title'),
                desc: t('item3_desc'),
                icons: [
                    {
                        icon: 'EFRuntime',
                        title: t('item3_text1'),
                    },
                    {
                        icon: 'EFExpand',
                        title: t('item3_text2'),
                    },
                    {
                        icon: 'EFBattery',
                        title: t('item3_text3'),
                    },
                    {
                        icon: 'EFUPS',
                        title: t('item3_text4'),
                    },
                ],
            },
        ],
    };
}
export function getEUItems(imgA: any, imgB: any, imgC: any, t: any, locale: string) {
    return {
        items: [
            {
                isAmazon: true,
                pc: imgA.pc,
                label: '',
                title: t('item1_title'),
                desc: t('item1_desc'),
                link_view: '',
                discountPrice: 249,
                originalPrice: 249,
                icons: [
                    {
                        icon: 'EFCompact',
                        title: t('item1_text1'),
                    },
                    {
                        icon: 'EFRuntime',
                        title: t('item1_text2'),
                    },
                    {
                        icon: 'EFBattery',
                        title: t('item1_text3'),
                    },
                    {
                        icon: 'EFUPS',
                        title: t('item1_text4'),
                    },
                ],
                link_more: (() => {
                    const maps: { [key: string]: any } = {
                        eu: 'https://eu.ecoflow.com/products/river-3-portable-power-station?variant=49500668723543',
                        uk: 'https://uk.ecoflow.com/products/river-3-portable-power-station?variant=49797546836307',
                        de: 'https://de.ecoflow.com/products/river-3-portable-power-station?variant=53660091449679',
                        fr: 'https://fr.ecoflow.com/products/river-3-portable-power-station?variant=49471449465179',
                        it: 'https://it.ecoflow.com/products/river-3-portable-power-station?variant=54724579918173',
                        es: 'https://es.ecoflow.com/products/river-3-portable-power-station?variant=49471467454811',
                    };
                    return maps[locale] || '';
                })(),
            },
            {
                isAmazon: true,
                pc: imgB.pc,
                label: t('price_label2_a'),
                title: t('item2_title'),
                desc: t('item2_desc'),
                link_more: (() => {
                    const maps: { [key: string]: any } = {
                        eu: 'https://eu.ecoflow.com/products/river-3-plus-portable-power-station?variant=50144528204119',
                        uk: 'https://uk.ecoflow.com/products/river-3-plus-portable-power-station?variant=50552824856915',
                        de: 'https://de.ecoflow.com/products/river-3-plus-portable-power-station?variant=55476457177469',
                        fr: 'https://fr.ecoflow.com/products/river-3-plus-portable-power-station',
                        it: 'https://it.ecoflow.com/products/river-3-plus-portable-power-station?variant=50209756053851',
                        es: 'https://es.ecoflow.com/products/river-3-plus-portable-power-station?variant=50209756053851',
                    };
                    return maps[locale] || '';
                })(),
                icons: [
                    {
                        icon: 'EFRuntime',
                        title: t('item2_text1'),
                    },
                    {
                        icon: 'EFExpand',
                        title: t('item2_text2'),
                    },
                    {
                        icon: 'EFBattery',
                        title: t('item2_text3'),
                    },
                    {
                        icon: 'EFUPS',
                        title: t('item2_text4'),
                    },
                ],
            },
            {
                isAmazon: true,
                pc: imgC.pc,
                label: t('price_label3_a'),
                title: t('item3_title'),
                desc: t('item3_desc'),
                link_more: (() => {
                    const maps: { [key: string]: any } = {
                        eu: 'https://eu.ecoflow.com/products/river-3-plus-portable-power-station?variant=50144528204119',
                        uk: 'https://uk.ecoflow.com/products/river-3-plus-portable-power-station?variant=50552824856915',
                        de: 'https://de.ecoflow.com/products/river-3-plus-portable-power-station?variant=55476457177469',
                        fr: 'https://fr.ecoflow.com/products/river-3-plus-portable-power-station',
                        it: 'https://it.ecoflow.com/products/river-3-plus-portable-power-station?variant=50209756053851',
                        es: 'https://es.ecoflow.com/products/river-3-plus-portable-power-station?variant=50209756053851',
                    };
                    return maps[locale] || '';
                })(),
                icons: [
                    {
                        icon: 'EFRuntime',
                        title: t('item3_text1'),
                    },
                    {
                        icon: 'EFExpand',
                        title: t('item3_text2'),
                    },
                    {
                        icon: 'EFBattery',
                        title: t('item3_text3'),
                    },
                    {
                        icon: 'EFUPS',
                        title: t('item3_text4'),
                    },
                ],
            },
        ],
    };
}
